module.exports = __webpack_public_path__ + "img/arrow-up-left.2ad5f162.svg";